import React, { useContext, useEffect, useState, useRef } from 'react'
import SeatContext from '../../context/SeatContext'
import { useNavigate } from 'react-router-dom'
import AlertContext from '../../context/AlertContext'
import Sidedash from '../uicomponents/Sidedash'
import Editslot from './Editslot'
import { useSettings } from '../../context/SettingsContext'
import { colorForLocation, uniqueSeatLocations } from '../../utils/locationColors'

const Seatsall = (props) => {
    const context = useContext(SeatContext)
    const { seats, setSeats, getAllSeats, updateSeatStatus, removeAssignedSlot } = context;
    const { settings } = useSettings();
    const history = useNavigate()
    const slotModalRef = useRef(null);
    const { showAlert } = useContext(AlertContext)
    const [slot, setSlot] = useState({})
    const [filter, setFilter] = useState(null); // null = all seats; otherwise a seatLocation value
    const [student, setStudent] = useState(null); // State variable to store student data

    useEffect(() => {
      console.log('Seatsall useEffect triggered'); // Debug log
      if (localStorage.getItem('token') && (localStorage.getItem('role') === 'Admin' || localStorage.getItem('role') === 'Superadmin')) {
            getAllSeats()
        } else if (localStorage.getItem('role') === 'Student') {
            showAlert("You aren't allowed to be here", "danger")
            history("/account");
        } else {
            showAlert("Please login to continue", "warning")
            history("/login");
        }

    }, [getAllSeats, history, showAlert])


    const handleCloseModal = () => {
        const modalElement = document.getElementById('staticBackdrop');
        modalElement.classList.remove('show'); // Adjust classes as needed for your Bootstrap version
        modalElement.removeAttribute('aria-modal'); // Optional step for accessibility
      };


    const handleSlotClick = async (e, currentSeat) => {
        // console.log(e.currentTarget); // Debug to see if this is the expected element
        // console.log(e.currentTarget.dataset.slot); 
        // Trigger modal or UI element that allows editing

        const slotName = e.currentTarget.dataset.slot;
        // Pre-fill the slot state with the current seat information and the slot to be edited
        if (currentSeat.seatStatus && currentSeat.seatStatus[slotName]) {
        setSlot({
            ...slot,
            seatId: currentSeat._id,
            slotName: slotName,
            bookedBy: currentSeat.seatStatus[slotName].bookedBy,
            seatValidTill: currentSeat.seatStatus[slotName].seatValidTill,
            useCustomValidity: !!currentSeat.seatStatus[slotName].seatValidTill,
            seatNumber: currentSeat.seatNumber
        })
        // fetching student data
        const uid = currentSeat.seatStatus[slotName].bookedBy;
        try {
            const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/students/show/uid/${uid}`); // Using the browser's fetch API
            const studentData = await response.json(); // Parse the JSON response
            setStudent(studentData);
            // Now you have the student data in the `student` variable
            // Use it to display information or perform actions
        } catch (error) {
            // Handle any errors that occurred during the API call
            console.error('Error fetching student:', error);
            // Provide appropriate error handling and feedback to the user
        }
        //console.log("Updating slot state with: ", slot); // Debugging log
        console.log(student, "student")
        if (slotModalRef.current) {
          slotModalRef.current.click();
      }
      //console.log(slotModalRef.current)
        } else {
             // Handle cases where slot data is missing, perhaps initializing with default values or showing an error/alert
        //console.log(`Slot data for '${slotName}' is missing in the current seat.`);
        }
    }

    useEffect(() => {
      //console.log(student); // Log when student changes
  }, [student]);


    const onChangeEdit = (e) => {
        setSlot({...slot, [e.target.name]: e.target.value});
    }

    const onCustomValidityChange = (checked) => {
        setSlot((prev) => ({ ...prev, useCustomValidity: checked }));
    };

    const slotUpdate = async () => {
        if (slot.seatId && slot.slotName && slot.bookedBy) {
          if (slot.useCustomValidity && !slot.seatValidTill) {
            showAlert("Please set a custom validity date", "warning");
            return;
          }
          try {
            const validityArg = slot.useCustomValidity ? slot.seatValidTill : undefined;
            const response = await updateSeatStatus(slot.seatId, slot.slotName, slot.bookedBy, validityArg);
            if(response.ok) {
              const { seat: updatedSeatData } = await response.json(); // Destructuring to get the updated seat directly
              // Assuming `seats` is the state you're using to render your seats
              setSeats(currentSeats => currentSeats.map(seat => {
                if (seat._id === updatedSeatData._id) { // Match the seat by ID and update
                  return updatedSeatData; // Use the updated seat data directly
                }
                return seat; // Return unmodified for other seats
              }));
      
              handleCloseModal(); // Close the modal
              setSlot({}); // Reset slot state
              showAlert(`Seat updated successfully`, "success");
            } else {
              throw new Error('Failed to update the seat.');
            }
          } catch (error) {
            console.error('Failed to update seat status:', error);
            showAlert("Update failed", "danger");
          }
        }
      };
     
    const makeSeatAvailable = async () => {
        const slotName = slot.slotName;
        const seatID = slot.seatId;
        try {
            const response = await removeAssignedSlot(seatID, slotName);
            console.log(response)
            if (response && response.ok) {
              showAlert("Seat removed successfully", "success");
            } else {
              showAlert("Operation completed, but check the details", "warning");
            }
            
          } catch (error) {
            showAlert("Failed to remove the seat", "error");
          }
    }

   // Unique seat locations derived from current seats (new locations appear as filters automatically)
   const seatLocations = uniqueSeatLocations(seats);
   const locationColors = settings?.locationColors || {};

   const getSeatColor = (seatLocation) => colorForLocation(seatLocation, seatLocations, locationColors);

   // Filter seats by selected seatLocation (null sentinel = show all; never collides with a location named "all")
   const filteredSeats = filter === null
     ? (Array.isArray(seats) ? seats : [])
     : (Array.isArray(seats) ? seats : []).filter((seat) => String(seat.seatLocation || '').trim() === filter);

    return (
        <>
            <div className="container-fluid seatsall" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <div className="row">
                    <Sidedash />
                    
                    <div className="col-md-9 pt-4 pb-5">
                        {/* Header Section */}
                        <div className="mb-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <div>
                                    <h2 className="mb-1" style={{ fontWeight: '600', color: '#2c3e50' }}>Seat Management</h2>
                                    <p className="text-muted mb-0" style={{ fontSize: '0.9rem' }}>Manage and monitor all library seats</p>
                                </div>
                                <button 
                                    className="btn btn-success" 
                                    onClick={() => history('/add-seat')}
                                    style={{ 
                                        padding: '0.6rem 1.5rem',
                                        borderRadius: '8px',
                                        fontWeight: '500',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                        border: 'none'
                                    }}
                                >
                                    <span style={{ marginRight: '0.5rem' }}>+</span> Add Seat
                                </button>
                            </div>
                            
                            {/* Filter Buttons — dynamically built from seatLocation */}
                            <div className="d-flex flex-wrap gap-2" style={{ marginTop: '1.5rem' }}>
                                <button 
                                    className={`btn ${filter === null ? 'btn-primary' : 'btn-outline-secondary'}`}
                                    onClick={() => setFilter(null)}
                                    style={{
                                        borderRadius: '20px',
                                        padding: '0.5rem 1.2rem',
                                        fontWeight: '500',
                                        fontSize: '0.9rem',
                                        transition: 'all 0.3s ease',
                                        border: filter === null ? 'none' : '1px solid #dee2e6'
                                    }}
                                >
                                    All Blocks
                                </button>
                                {seatLocations.map((location) => (
                                    <button 
                                        key={location}
                                        className={`btn ${filter === location ? 'btn-primary' : 'btn-outline-secondary'}`}
                                        onClick={() => setFilter(location)}
                                        style={{
                                            borderRadius: '20px',
                                            padding: '0.5rem 1.2rem',
                                            fontWeight: '500',
                                            fontSize: '0.9rem',
                                            transition: 'all 0.3s ease',
                                            border: filter === location ? 'none' : '1px solid #dee2e6'
                                        }}
                                    >
                                        {location}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Seats Grid */}
                        <div className="row g-4">
                            {filteredSeats.length === 0 && (
                                <div className="col-12">
                                    <div className="alert alert-info" style={{ 
                                        borderRadius: '12px', 
                                        border: 'none',
                                        backgroundColor: '#e7f3ff',
                                        color: '#004085',
                                        padding: '1.5rem',
                                        textAlign: 'center'
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-info-circle mb-2" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z"/>
                                            <circle cx="8" cy="4.5" r="1"/>
                                        </svg>
                                        <div style={{ fontWeight: '500', fontSize: '1rem' }}>No seats matching the criteria!</div>
                                    </div>
                                </div>
                            )}
                            {filteredSeats.map((seat) => {
                                // check if subscription expired
                                const validTillm = seat.seatStatus.morning.seatValidTill;
                                const validTilla = seat.seatStatus.afternoon.seatValidTill;
                                const validTille = seat.seatStatus.evening.seatValidTill;
                                const validTilln = seat.seatStatus.night.seatValidTill;
                                
                                return (
                                    <div key={seat._id} className="col-lg-6 col-xl-4 col-xxl-3">
                                        <div 
                                            className="card text-white h-100" 
                                            style={{
                                                ...getSeatColor(seat.seatLocation),
                                                borderRadius: '16px',
                                                border: 'none',
                                                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                                                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                                                overflow: 'hidden'
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'translateY(-4px)';
                                                e.currentTarget.style.boxShadow = '0 8px 20px rgba(0,0,0,0.2)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'translateY(0)';
                                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
                                            }}
                                        >
                                            <div className="card-body" style={{ padding: '1.5rem' }}>
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <div className="flex-grow-1">
                                                        <div 
                                                            className="badge mb-2" 
                                                            style={{ 
                                                                backgroundColor: 'rgba(255, 255, 255, 0.25)',
                                                                color: 'white',
                                                                padding: '0.4rem 0.8rem',
                                                                borderRadius: '8px',
                                                                fontSize: '0.75rem',
                                                                fontWeight: '600',
                                                                cursor: 'pointer',
                                                                transition: 'background-color 0.2s ease'
                                                            }}
                                                            onClick={() => history(`/edit-seat/${seat._id}`)}
                                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.35)'}
                                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.25)'}
                                                        >
                                                            ✏️ Edit
                                                        </div>
                                                        <div style={{ 
                                                            fontSize: '1.1rem', 
                                                            fontWeight: '500',
                                                            marginBottom: '0.25rem',
                                                            color: 'rgba(255, 255, 255, 0.95)'
                                                        }}>
                                                            {seat.seatLocation}
                                                        </div>
                                                        <div style={{ 
                                                            fontSize: '0.85rem', 
                                                            color: 'rgba(255, 255, 255, 0.7)'
                                                        }}>
                                                            Location
                                                        </div>
                                                    </div>
                                                    <div style={{ 
                                                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                                        borderRadius: '12px',
                                                        padding: '0.75rem',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="rgba(255, 255, 255, 0.9)" className="bi bi-shield" viewBox="0 0 16 16">
                                                            <path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/>
                                                            <text x="50%" y="55%" fontSize="6" textAnchor="middle" fill="white" fontWeight="bold">{seat.seatNumber}</text>
                                                        </svg>
                                                    </div>
                                                </div>
                                            </div>
                                            <div 
                                                className="card-footer" 
                                                style={{ 
                                                    backgroundColor: 'rgba(0, 0, 0, 0.15)',
                                                    border: 'none',
                                                    padding: '1rem 1.5rem'
                                                }}
                                            >
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div style={{ fontSize: '0.75rem', color: 'rgba(255, 255, 255, 0.8)', fontWeight: '500' }}>Time Slots</div>
                                                </div>
                                                <div className="d-flex justify-content-between align-items-center mt-2" style={{ gap: '0.5rem' }}>
                                                    <span 
                                                        role="button" 
                                                        data-slot="morning" 
                                                        onClick={(e)=>handleSlotClick(e, seat)}
                                                        style={{ 
                                                            cursor: 'pointer',
                                                            transition: 'transform 0.2s ease',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            gap: '0.25rem'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                    >
                                                        <svg className='chair-svg' width="32" height="32" fill={validTillm && new Date(validTillm) < new Date() ? "#f96565" : (seat.seatStatus && seat.seatStatus.morning.status ? "#1b4256" : "#c4d8f3")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                                            <path d="M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z" />
                                                            <title>Morning slot {seat.seatStatus.morning.status ? "unavailable" : "available"}</title>
                                                        </svg>
                                                        <span style={{ fontSize: '0.65rem', color: 'rgba(255, 255, 255, 0.7)' }}>Morn</span>
                                                    </span>
                                                    <span 
                                                        role="button" 
                                                        data-slot="afternoon" 
                                                        onClick={(e)=>handleSlotClick(e, seat)}
                                                        style={{ 
                                                            cursor: 'pointer',
                                                            transition: 'transform 0.2s ease',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            gap: '0.25rem'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                    >
                                                        <svg className='chair-svg' width="32" height="32" fill={validTilla && new Date(validTilla) < new Date() ? "#f96565" : (seat.seatStatus && seat.seatStatus.afternoon.status ? "#1b4256" : "#c4d8f3")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                                            <path d="M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z" />
                                                            <title>Afternoon slot {seat.seatStatus.afternoon.status ? "unavailable" : "available"}</title>
                                                        </svg>
                                                        <span style={{ fontSize: '0.65rem', color: 'rgba(255, 255, 255, 0.7)' }}>Aft</span>
                                                    </span>
                                                    <span 
                                                        role="button" 
                                                        data-slot="evening" 
                                                        onClick={(e)=>handleSlotClick(e, seat)}
                                                        style={{ 
                                                            cursor: 'pointer',
                                                            transition: 'transform 0.2s ease',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            gap: '0.25rem'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                    >
                                                        <svg className='chair-svg' width="32" height="32" fill={validTille && new Date(validTille) < new Date() ? "#f96565" : (seat.seatStatus && seat.seatStatus.evening.status ? "#1b4256" : "#c4d8f3")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                                            <path d="M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z" />
                                                            <title>Evening slot {seat.seatStatus.evening.status ? "unavailable" : "available"}</title>
                                                        </svg>
                                                        <span style={{ fontSize: '0.65rem', color: 'rgba(255, 255, 255, 0.7)' }}>Eve</span>
                                                    </span>
                                                    <span 
                                                        role="button" 
                                                        data-slot="night" 
                                                        onClick={(e)=>handleSlotClick(e, seat)}
                                                        style={{ 
                                                            cursor: 'pointer',
                                                            transition: 'transform 0.2s ease',
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            alignItems: 'center',
                                                            gap: '0.25rem'
                                                        }}
                                                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                                    >
                                                        <svg className='chair-svg' width="32" height="32" fill={validTilln && new Date(validTilln) < new Date() ? "#f96565" : (seat.seatStatus && seat.seatStatus.night.status ? "#1b4256" : "#c4d8f3")} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                                            <path d="M64 160C64 89.3 121.3 32 192 32H448c70.7 0 128 57.3 128 128v33.6c-36.5 7.4-64 39.7-64 78.4v48H128V272c0-38.7-27.5-71-64-78.4V160zM544 272c0-20.9 13.4-38.7 32-45.3c5-1.8 10.4-2.7 16-2.7c26.5 0 48 21.5 48 48V448c0 17.7-14.3 32-32 32H576c-17.7 0-32-14.3-32-32H96c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V272c0-26.5 21.5-48 48-48c5.6 0 11 1 16 2.7c18.6 6.6 32 24.4 32 45.3v48 32h32H512h32V320 272z" />
                                                            <title>Night slot {seat.seatStatus.night.status ? "unavailable" : "available"}</title>
                                                        </svg>
                                                        <span style={{ fontSize: '0.65rem', color: 'rgba(255, 255, 255, 0.7)' }}>Night</span>
                                                    </span>     
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <Editslot ref={slotModalRef} slot={slot} onChangeEdit={onChangeEdit} slotUpdate={slotUpdate} makeSeatAvailable={makeSeatAvailable} student={student} onCustomValidityChange={onCustomValidityChange} />


        </>
    )
}

export default Seatsall

